$(document).ready(function(){
    
    // Parralaxing Homepage Banner
    if($(".section-home").length > 0) {

        var scene = document.getElementById('scene');
        var parallax = new Parallax(scene, {
            limitX: 50,
            limitY: 50
        });

        var $movingBox = $('.movingBox');

        $("#scene > .movingBox:gt(0)").hide();
  
        setInterval(function() {
            $('#scene > .movingBox:first')
                .fadeOut(2000)
                .next()
                .fadeIn(2000)
                .end()
                .appendTo('#scene');
        }, 5000);

    }

});


